import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { greyScaleColors, semanticColors } from '../../../Globals/styles'
import DelegateHoursStep from './delegateHoursStep';
import AbsenceStep from './absenceStep';
import Waves from 'node-waves'

class ActivityOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
      solvedConflicts: [],
      navSteps: []
    }
  }
  componentWillMount = () => {
    const { employeesWithConflict } = this.props;
    let navSteps = [];
    let solvedConflicts = this.state.solvedConflicts;

    employeesWithConflict.forEach((conflictedEmployee, index) => {
      //create the init object for the employee
      solvedConflicts[index] = {
        id: conflictedEmployee.id,
        //if employee only has one activity, its already solved, and if he has more then empty list, so the delegater step can solve it.
        activities: conflictedEmployee.activities.length === 1 ? conflictedEmployee.activities : [],
        hours: conflictedEmployee.hours,
        nightHours: conflictedEmployee.nightHours,
        employeeIndex: conflictedEmployee.employeeIndex
      }
      //create step for hour solving
      if (conflictedEmployee.activities.length > 1){
        navSteps.push({type: 'hours', employeeIndex: index})
      }
      //create step for absence solving
      if(conflictedEmployee.absence){
        navSteps.push({type: 'absent', employeeIndex: index})
        solvedConflicts[index].absence = {
          ...conflictedEmployee.absence
        }
      }
    })
    this.setState({
      navSteps: navSteps,
      solvedConflicts: solvedConflicts
    })
  };
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  onClickForward = () => {
    if(this.isCurrentStepValid())
      this.setState({
        currentStep: this.state.currentStep+1
      })
  };
  onClickBack = () => {
    this.setState({
      currentStep: this.state.currentStep-1
    })
  };
  handleHoursConflict = (value, index) => {
    let solvedConflicts = this.state.solvedConflicts;
    solvedConflicts[index].activities = value;
    this.setState({
      solvedConflicts: solvedConflicts
    })
  };
  handleAbsenceConflict = (absence, index) => {
    let solvedConflicts = this.state.solvedConflicts;
    solvedConflicts[index].absence = absence;
    this.setState({
      solvedConflicts: solvedConflicts
    })
  };
  isCurrentStepValid = () => {
    if(this.state.navSteps[this.state.currentStep].type==='absent' &&
      !this.state.solvedConflicts[this.state.navSteps[this.state.currentStep].employeeIndex].absence.absenceCode)
      return false;
    return true
  };

  render () {
    const { employeesWithConflict, activities, attemptSaveConflictedEmployees,
            isSavingConflicted, registrationDate } = this.props;
    const { navSteps, currentStep, solvedConflicts } = this.state;

    var navStepNodes = this.state.navSteps.map((k, index) => {
      return (
        <i
          key={index}
          className="fa fa-circle"
          style={[
            styles.circle,
            index===currentStep && styles.circleActive]
        }/>)
    });
    return (
      <div>
        <div style={styles.overlay}></div>
        <div style={styles.wizardContainer}>
          <div style={styles.stepContainer}>
          {navSteps[currentStep].type==='hours' ?
            <DelegateHoursStep
              key={employeesWithConflict[navSteps[currentStep].employeeIndex].id}
              activities={activities}
              employee={employeesWithConflict[navSteps[currentStep].employeeIndex]}
              index={navSteps[currentStep].employeeIndex}
              handleConflict={this.handleHoursConflict}
              initValues={solvedConflicts[navSteps[currentStep].employeeIndex].activities}
            />
            :
            <AbsenceStep
              key={employeesWithConflict[navSteps[currentStep].employeeIndex].id}
              employee={employeesWithConflict[navSteps[currentStep].employeeIndex]}
              index={navSteps[currentStep].employeeIndex}
              handleConflict={this.handleAbsenceConflict}
              initValue={solvedConflicts[navSteps[currentStep].employeeIndex].absence}
              registrationDate={registrationDate}
            />}
          </div>
          <div style={styles.nav}>
            {currentStep !== 0 ?
              <i
                className="fa fa-arrow-left waves-icon"
                onClick={this.onClickBack}
                style={[styles.arrows, styles.backArrow]}/>
              :null}

            <div style={styles.navSteps}>
              {navStepNodes}
            </div>
            {currentStep !== navSteps.length-1 ?
              <i
                className="fa fa-arrow-right waves-icon"
                onClick={this.onClickForward}
                style={[styles.arrows, styles.forwardArrow]} />
              :
              <div>
                {this.isCurrentStepValid() ?
                  <button style={styles.saveButton} className="btn btn-success waves-btn" onClick={() => attemptSaveConflictedEmployees(solvedConflicts)}>
                    {isSavingConflicted ? (<i style={styles.spinner} className="fa fa-spinner fa-spin"/>) : "Registrer"}
                  </button>
                  :null
                }
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

var styles = {
  overlay: {
    width:'100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    backgroundColor: greyScaleColors.grey,
    opacity: '0.6',
    zIndex: '1001'
  },
  wizardContainer:{
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: '1002',
    backgroundColor: semanticColors.default,
    width: '658px',
    height: '330px',
    marginTop: '-165px',
    marginLeft: '-329px',
    padding: '0 40px'
  },
  stepContainer:{
    marginLeft: 'auto',
    marginRight: 'auto',
    height: '280px'
  },
  nav: {
    lineHeight: '50px',
    fontSize: '20px',
    textAlign: 'center',
    position: 'relative'
  },
  arrows: {
    lineHeight: '30px',
    position: 'absolute',
    width: '30px',
    height:'30px'
  },
  backArrow:{
    left: '0'
  },
  forwardArrow:{
    right: '0'
  },
  navSteps:{
    display: 'inline-block'
  },
  circle: {
    padding: '0 2px',
    color: greyScaleColors.grey
  },
  circleActive: {
    color: semanticColors.info
  },
  saveButton: {
    position: 'absolute',
    right: '0',
    top: '5px',
    width: '100px',
    fontSize: '14px'
  },
  spinner: {
    fontSize: '21px'
  }
}
  ActivityOverview.propTypes = {
    employeesWithConflict: PropTypes.array.isRequired,
    activities: PropTypes.object.isRequired,
    attemptSaveConflictedEmployees: PropTypes.func.isRequired,
    isSavingConflicted: PropTypes.bool.isRequired,
    registrationDate: PropTypes.instanceOf(Date).isRequired
  };

export default Radium(ActivityOverview)


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/ConflictWizard/index.jsx